module.exports = __webpack_public_path__ + "78c56cf67a0ea36dd2ece135a8a340af.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/LiveCampus 雲端版線上學習.pdf
// module id = 115
// module chunks = 3